const economicsQuestions = [

{
  question: "Economics is the study of:",
  options: ["allocation of scarce resources", "production only", "money only", "government only"],
  answer: "allocation of scarce resources"
},
{
  question: "Scarcity means:",
  options: ["limited resources with unlimited wants", "abundance of goods", "no wants", "free goods"],
  answer: "limited resources with unlimited wants"
},
{
  question: "Opportunity cost is:",
  options: ["next best alternative forgone", "total cost", "money spent", "profit"],
  answer: "next best alternative forgone"
},
{
  question: "If a student chooses to study instead of working, the opportunity cost is:",
  options: ["income foregone", "tuition fees", "books", "transport"],
  answer: "income foregone"
},
{
  question: "Factors of production include:",
  options: ["land, labour, capital, entrepreneur", "money only", "labour only", "capital only"],
  answer: "land, labour, capital, entrepreneur"
},
{
  question: "Payment for labour is:",
  options: ["wages", "rent", "interest", "profit"],
  answer: "wages"
},
{
  question: "Payment for land is:",
  options: ["rent", "wages", "interest", "profit"],
  answer: "rent"
},
{
  question: "Payment for capital is:",
  options: ["interest", "wages", "rent", "profit"],
  answer: "interest"
},
{
  question: "Entrepreneur earns:",
  options: ["profit", "rent", "wages", "interest"],
  answer: "profit"
},
{
  question: "A production possibility curve shows:",
  options: ["maximum output combinations", "demand only", "supply only", "cost only"],
  answer: "maximum output combinations"
},
{
  question: "Points inside PPC indicate:",
  options: ["inefficiency", "efficiency", "growth", "profit"],
  answer: "inefficiency"
},
{
  question: "Points on PPC indicate:",
  options: ["efficient use of resources", "inefficiency", "loss", "profit"],
  answer: "efficient use of resources"
},
{
  question: "Points outside PPC indicate:",
  options: ["unattainable output", "efficiency", "waste", "loss"],
  answer: "unattainable output"
},
{
  question: "Economic growth shifts PPC:",
  options: ["outward", "inward", "downward", "left"],
  answer: "outward"
},
{
  question: "Choice arises due to:",
  options: ["scarcity", "abundance", "wealth", "income"],
  answer: "scarcity"
},
{
  question: "A free good is:",
  options: ["not scarce", "very expensive", "limited", "valuable"],
  answer: "not scarce"
},
{
  question: "An economic good is:",
  options: ["scarce and has value", "free", "unlimited", "not useful"],
  answer: "scarce and has value"
},
{
  question: "Efficiency means:",
  options: ["maximum output with given resources", "waste", "loss", "cost"],
  answer: "maximum output with given resources"
},
{
  question: "Capital goods are:",
  options: ["used for production", "for consumption", "free goods", "services"],
  answer: "used for production"
},
{
  question: "Consumer goods are:",
  options: ["used for satisfaction", "used in production", "capital", "services"],
  answer: "used for satisfaction"
},
{
  question: "Positive economics deals with:",
  options: ["facts", "opinions", "values", "judgment"],
  answer: "facts"
},
{
  question: "Normative economics deals with:",
  options: ["opinions", "facts", "data", "numbers"],
  answer: "opinions"
},
{
  question: "Microeconomics studies:",
  options: ["individual units", "whole economy", "global economy", "government"],
  answer: "individual units"
},
{
  question: "Macroeconomics studies:",
  options: ["entire economy", "individual firm", "consumer only", "market only"],
  answer: "entire economy"
},
{
  question: "A rational consumer aims to:",
  options: ["maximize satisfaction", "waste income", "minimize output", "increase cost"],
  answer: "maximize satisfaction"
},
{
  question: "Economic problem arises due to:",
  options: ["scarcity", "wealth", "abundance", "money"],
  answer: "scarcity"
},
{
  question: "Division of labour leads to:",
  options: ["specialization", "waste", "loss", "inefficiency"],
  answer: "specialization"
},
{
  question: "Specialization improves:",
  options: ["productivity", "waste", "loss", "cost"],
  answer: "productivity"
},
{
  question: "Basic economic problem is:",
  options: ["what, how, for whom to produce", "profit only", "cost only", "sales only"],
  answer: "what, how, for whom to produce"
},
{
  question: "Economics helps in:",
  options: ["decision making", "wasting resources", "loss", "confusion"],
  answer: "decision making"
},

{
  question: "Demand is defined as:",
  options: ["willingness and ability to buy", "desire only", "ability only", "need only"],
  answer: "willingness and ability to buy"
},
{
  question: "The law of demand states that:",
  options: ["price falls, quantity demanded rises", "price rises, demand rises", "price constant, demand rises", "income rises, demand falls"],
  answer: "price falls, quantity demanded rises"
},
{
  question: "A demand schedule shows:",
  options: ["relationship between price and quantity", "supply only", "cost only", "profit only"],
  answer: "relationship between price and quantity"
},
{
  question: "A demand curve is typically:",
  options: ["downward sloping", "upward sloping", "vertical", "horizontal"],
  answer: "downward sloping"
},
{
  question: "If price of rice falls from GH¢10 to GH¢8 and demand rises, this illustrates:",
  options: ["law of demand", "law of supply", "equilibrium", "inflation"],
  answer: "law of demand"
},
{
  question: "A movement along demand curve is caused by:",
  options: ["change in price", "income change", "taste change", "population"],
  answer: "change in price"
},
{
  question: "Shift in demand curve is caused by:",
  options: ["income change", "price change", "cost change", "technology"],
  answer: "income change"
},
{
  question: "If income increases and demand for a good increases, it is:",
  options: ["normal good", "inferior good", "luxury only", "free good"],
  answer: "normal good"
},
{
  question: "If income increases and demand falls, it is:",
  options: ["inferior good", "normal good", "luxury good", "capital good"],
  answer: "inferior good"
},
{
  question: "Substitute goods are goods that:",
  options: ["replace each other", "used together", "not related", "free"],
  answer: "replace each other"
},
{
  question: "If price of tea rises and demand for coffee rises, they are:",
  options: ["substitutes", "complements", "independent", "inferior"],
  answer: "substitutes"
},
{
  question: "Complementary goods are goods that:",
  options: ["used together", "replace each other", "not related", "free"],
  answer: "used together"
},
{
  question: "If price of petrol rises, demand for cars may:",
  options: ["fall", "rise", "remain same", "double"],
  answer: "fall"
},
{
  question: "Price elasticity of demand measures:",
  options: ["responsiveness of demand to price", "cost", "profit", "income"],
  answer: "responsiveness of demand to price"
},
{
  question: "Elastic demand means:",
  options: ["large change in quantity", "small change", "no change", "constant"],
  answer: "large change in quantity"
},
{
  question: "Inelastic demand means:",
  options: ["small response to price change", "large response", "no demand", "infinite"],
  answer: "small response to price change"
},
{
  question: "If PED > 1, demand is:",
  options: ["elastic", "inelastic", "unitary", "zero"],
  answer: "elastic"
},
{
  question: "If PED < 1, demand is:",
  options: ["inelastic", "elastic", "unitary", "perfect"],
  answer: "inelastic"
},
{
  question: "If PED = 1, demand is:",
  options: ["unitary", "elastic", "inelastic", "perfect"],
  answer: "unitary"
},
{
  question: "If price rises by 10% and demand falls by 20%, PED is:",
  options: ["2", "0.5", "1", "10"],
  answer: "2"
},
{
  question: "If price rises by 10% and demand falls by 5%, PED is:",
  options: ["0.5", "2", "1", "5"],
  answer: "0.5"
},
{
  question: "Goods with many substitutes have:",
  options: ["elastic demand", "inelastic demand", "unitary demand", "zero demand"],
  answer: "elastic demand"
},
{
  question: "Necessities have:",
  options: ["inelastic demand", "elastic demand", "unitary", "perfect"],
  answer: "inelastic demand"
},
{
  question: "Luxury goods have:",
  options: ["elastic demand", "inelastic demand", "unitary", "perfect"],
  answer: "elastic demand"
},
{
  question: "Short run demand is usually:",
  options: ["inelastic", "elastic", "unitary", "perfect"],
  answer: "inelastic"
},
{
  question: "Long run demand is usually:",
  options: ["elastic", "inelastic", "unitary", "fixed"],
  answer: "elastic"
},
{
  question: "If price falls and total revenue increases, demand is:",
  options: ["elastic", "inelastic", "unitary", "perfect"],
  answer: "elastic"
},
{
  question: "If price falls and total revenue falls, demand is:",
  options: ["inelastic", "elastic", "unitary", "perfect"],
  answer: "inelastic"
},
{
  question: "Demand curve shifts right when:",
  options: ["income rises", "price rises", "cost rises", "tax increases"],
  answer: "income rises"
},
{
  question: "Demand curve shifts left when:",
  options: ["income falls", "price falls", "supply rises", "cost falls"],
  answer: "income falls"
},

{
  question: "Utility refers to:",
  options: ["satisfaction from consumption", "price of goods", "cost of goods", "income"],
  answer: "satisfaction from consumption"
},
{
  question: "Total utility is:",
  options: ["total satisfaction from all units", "satisfaction per unit", "cost of goods", "price"],
  answer: "total satisfaction from all units"
},
{
  question: "Marginal utility is:",
  options: ["extra satisfaction from one more unit", "total satisfaction", "average cost", "price"],
  answer: "extra satisfaction from one more unit"
},
{
  question: "Law of diminishing marginal utility states:",
  options: ["MU falls as consumption increases", "MU rises always", "MU constant", "MU zero"],
  answer: "MU falls as consumption increases"
},
{
  question: "If MU becomes zero, total utility is:",
  options: ["maximum", "minimum", "zero", "negative"],
  answer: "maximum"
},
{
  question: "If MU becomes negative, total utility:",
  options: ["falls", "rises", "constant", "zero"],
  answer: "falls"
},
{
  question: "A rational consumer aims to:",
  options: ["maximize satisfaction", "maximize cost", "minimize utility", "ignore price"],
  answer: "maximize satisfaction"
},
{
  question: "Consumer equilibrium occurs when:",
  options: ["MU = price", "price = income", "TU = zero", "cost = revenue"],
  answer: "MU = price"
},
{
  question: "If MU > price, consumer should:",
  options: ["consume more", "consume less", "stop consumption", "ignore"],
  answer: "consume more"
},
{
  question: "If MU < price, consumer should:",
  options: ["consume less", "consume more", "increase income", "ignore"],
  answer: "consume less"
},
{
  question: "A consumer buys until:",
  options: ["MU = price", "MU = zero", "price = income", "TU = zero"],
  answer: "MU = price"
},
{
  question: "Total utility curve is:",
  options: ["upward then flat", "downward", "horizontal", "vertical"],
  answer: "upward then flat"
},
{
  question: "Marginal utility curve is:",
  options: ["downward sloping", "upward", "horizontal", "vertical"],
  answer: "downward sloping"
},
{
  question: "If MU of last unit is 5 and price is 5, consumer is:",
  options: ["in equilibrium", "not in equilibrium", "losing", "gaining"],
  answer: "in equilibrium"
},
{
  question: "If MU of last unit is 10 and price is 5:",
  options: ["consume more", "consume less", "stop", "no change"],
  answer: "consume more"
},
{
  question: "If MU of last unit is 3 and price is 5:",
  options: ["consume less", "consume more", "increase income", "no change"],
  answer: "consume less"
},
{
  question: "Utility is subjective because:",
  options: ["varies among individuals", "same for all", "constant", "fixed"],
  answer: "varies among individuals"
},
{
  question: "Cardinal utility assumes:",
  options: ["utility can be measured", "cannot be measured", "no utility", "fixed utility"],
  answer: "utility can be measured"
},
{
  question: "Ordinal utility assumes:",
  options: ["utility can be ranked", "measured in numbers", "fixed", "constant"],
  answer: "utility can be ranked"
},
{
  question: "Indifference curve shows:",
  options: ["equal satisfaction combinations", "cost curve", "demand curve", "supply curve"],
  answer: "equal satisfaction combinations"
},
{
  question: "Indifference curves are:",
  options: ["downward sloping", "upward", "vertical", "horizontal"],
  answer: "downward sloping"
},
{
  question: "Indifference curves cannot:",
  options: ["intersect", "exist", "slope", "curve"],
  answer: "intersect"
},
{
  question: "Budget line shows:",
  options: ["income and prices", "cost only", "profit", "utility"],
  answer: "income and prices"
},
{
  question: "Consumer equilibrium (indifference approach) occurs where:",
  options: ["IC touches budget line", "IC above budget", "IC below", "price equals income"],
  answer: "IC touches budget line"
},
{
  question: "If income increases, budget line:",
  options: ["shifts outward", "inward", "rotates", "disappears"],
  answer: "shifts outward"
},
{
  question: "If price of a good falls, budget line:",
  options: ["rotates outward", "inward", "shifts parallel", "no change"],
  answer: "rotates outward"
},
{
  question: "Substitution effect occurs due to:",
  options: ["price change", "income change", "tax", "population"],
  answer: "price change"
},
{
  question: "Income effect occurs due to:",
  options: ["change in purchasing power", "price only", "cost only", "supply"],
  answer: "change in purchasing power"
},
{
  question: "Normal goods have:",
  options: ["positive income effect", "negative", "zero", "constant"],
  answer: "positive income effect"
},
{
  question: "Inferior goods have:",
  options: ["negative income effect", "positive", "zero", "constant"],
  answer: "negative income effect"
},

{
  question: "Production refers to:",
  options: ["creation of utility", "buying goods", "selling goods", "consuming goods"],
  answer: "creation of utility"
},
{
  question: "Fixed factors are:",
  options: ["cannot be changed in short run", "changeable", "variable", "mobile"],
  answer: "cannot be changed in short run"
},
{
  question: "Variable factors are:",
  options: ["changeable in short run", "fixed", "constant", "permanent"],
  answer: "changeable in short run"
},
{
  question: "Total product (TP) is:",
  options: ["total output produced", "output per unit", "extra output", "cost"],
  answer: "total output produced"
},
{
  question: "Average product (AP) =",
  options: ["TP / number of workers", "TP × workers", "TP − workers", "TP + workers"],
  answer: "TP / number of workers"
},
{
  question: "Marginal product (MP) is:",
  options: ["extra output from one more unit", "total output", "average output", "cost"],
  answer: "extra output from one more unit"
},
{
  question: "If TP = 100 and workers = 5, AP is:",
  options: ["20", "100", "5", "25"],
  answer: "20"
},
{
  question: "If TP increases from 50 to 70, MP is:",
  options: ["20", "70", "50", "120"],
  answer: "20"
},
{
  question: "Law of diminishing returns states:",
  options: ["MP eventually falls", "MP always rises", "TP constant", "cost constant"],
  answer: "MP eventually falls"
},
{
  question: "If MP becomes zero, TP is:",
  options: ["maximum", "minimum", "zero", "negative"],
  answer: "maximum"
},
{
  question: "If MP becomes negative, TP:",
  options: ["falls", "rises", "constant", "zero"],
  answer: "falls"
},
{
  question: "Stage of rational production is where:",
  options: ["MP positive but falling", "MP negative", "MP zero", "TP falling"],
  answer: "MP positive but falling"
},
{
  question: "Total cost (TC) =",
  options: ["fixed cost + variable cost", "fixed only", "variable only", "revenue"],
  answer: "fixed cost + variable cost"
},
{
  question: "If FC = 100 and VC = 200, TC is:",
  options: ["300", "100", "200", "400"],
  answer: "300"
},
{
  question: "Average cost (AC) =",
  options: ["TC / output", "TC × output", "TC − output", "TC + output"],
  answer: "TC / output"
},
{
  question: "If TC = 500 and output = 50, AC is:",
  options: ["10", "50", "500", "25"],
  answer: "10"
},
{
  question: "Marginal cost (MC) is:",
  options: ["extra cost of one more unit", "total cost", "average cost", "fixed cost"],
  answer: "extra cost of one more unit"
},
{
  question: "If TC increases from 400 to 450, MC is:",
  options: ["50", "400", "450", "850"],
  answer: "50"
},
{
  question: "Fixed cost does not change with:",
  options: ["output", "price", "income", "demand"],
  answer: "output"
},
{
  question: "Variable cost changes with:",
  options: ["output", "time", "income", "tax"],
  answer: "output"
},
{
  question: "If FC = 200 and output = 10, AFC is:",
  options: ["20", "200", "10", "100"],
  answer: "20"
},
{
  question: "As output increases, AFC:",
  options: ["falls", "rises", "constant", "zero"],
  answer: "falls"
},
{
  question: "If TC = 600, FC = 200, VC is:",
  options: ["400", "600", "200", "800"],
  answer: "400"
},
{
  question: "If output rises from 20 to 30 and TC rises from 200 to 260, MC:",
  options: ["6", "60", "2", "10"],
  answer: "6"
},
{
  question: "Efficiency in production means:",
  options: ["minimum cost for output", "maximum cost", "loss", "waste"],
  answer: "minimum cost for output"
},
{
  question: "Short run is defined as:",
  options: ["period with fixed factors", "all factors variable", "no production", "long time"],
  answer: "period with fixed factors"
},
{
  question: "Long run is:",
  options: ["all factors variable", "fixed factors only", "short period", "no change"],
  answer: "all factors variable"
},
{
  question: "Economies of scale lead to:",
  options: ["lower cost", "higher cost", "no change", "loss"],
  answer: "lower cost"
},
{
  question: "Diseconomies of scale lead to:",
  options: ["higher cost", "lower cost", "profit", "no change"],
  answer: "higher cost"
},
{
  question: "Production helps firms to:",
  options: ["create value", "destroy goods", "reduce output", "increase waste"],
  answer: "create value"
},

{
  question: "Supply is defined as:",
  options: ["willingness and ability to sell", "desire only", "ability only", "production only"],
  answer: "willingness and ability to sell"
},
{
  question: "Law of supply states that:",
  options: ["price rises, quantity supplied rises", "price rises, supply falls", "price constant", "income rises"],
  answer: "price rises, quantity supplied rises"
},
{
  question: "A supply curve is:",
  options: ["upward sloping", "downward sloping", "horizontal", "vertical"],
  answer: "upward sloping"
},
{
  question: "Movement along supply curve is caused by:",
  options: ["change in price", "technology", "tax", "weather"],
  answer: "change in price"
},
{
  question: "Shift in supply curve is caused by:",
  options: ["technology change", "price change", "income", "demand"],
  answer: "technology change"
},
{
  question: "Improvement in technology will:",
  options: ["increase supply", "decrease supply", "no change", "reduce demand"],
  answer: "increase supply"
},
{
  question: "Increase in tax will:",
  options: ["reduce supply", "increase supply", "no change", "increase demand"],
  answer: "reduce supply"
},
{
  question: "Subsidy will:",
  options: ["increase supply", "reduce supply", "no change", "reduce demand"],
  answer: "increase supply"
},
{
  question: "Elasticity of supply measures:",
  options: ["responsiveness of supply to price", "cost", "profit", "income"],
  answer: "responsiveness of supply to price"
},
{
  question: "If PES > 1, supply is:",
  options: ["elastic", "inelastic", "unitary", "zero"],
  answer: "elastic"
},
{
  question: "If PES < 1, supply is:",
  options: ["inelastic", "elastic", "unitary", "perfect"],
  answer: "inelastic"
},
{
  question: "If PES = 1, supply is:",
  options: ["unitary", "elastic", "inelastic", "perfect"],
  answer: "unitary"
},
{
  question: "If price rises by 10% and supply rises by 20%, PES is:",
  options: ["2", "0.5", "1", "10"],
  answer: "2"
},
{
  question: "If price rises by 10% and supply rises by 5%, PES is:",
  options: ["0.5", "2", "1", "5"],
  answer: "0.5"
},
{
  question: "In the short run, supply is usually:",
  options: ["inelastic", "elastic", "unitary", "perfect"],
  answer: "inelastic"
},
{
  question: "In the long run, supply is usually:",
  options: ["elastic", "inelastic", "unitary", "fixed"],
  answer: "elastic"
},
{
  question: "Market equilibrium occurs where:",
  options: ["demand equals supply", "demand exceeds supply", "supply exceeds demand", "price zero"],
  answer: "demand equals supply"
},
{
  question: "Equilibrium price is determined by:",
  options: ["intersection of demand and supply", "government only", "cost only", "profit"],
  answer: "intersection of demand and supply"
},
{
  question: "If price is above equilibrium, there is:",
  options: ["surplus", "shortage", "equilibrium", "loss"],
  answer: "surplus"
},
{
  question: "If price is below equilibrium, there is:",
  options: ["shortage", "surplus", "equilibrium", "profit"],
  answer: "shortage"
},
{
  question: "If demand increases, equilibrium price:",
  options: ["rises", "falls", "same", "zero"],
  answer: "rises"
},
{
  question: "If supply increases, equilibrium price:",
  options: ["falls", "rises", "same", "zero"],
  answer: "falls"
},
{
  question: "If both demand and supply increase, price:",
  options: ["may rise or fall", "must rise", "must fall", "zero"],
  answer: "may rise or fall"
},
{
  question: "If demand decreases, equilibrium quantity:",
  options: ["falls", "rises", "same", "zero"],
  answer: "falls"
},
{
  question: "If supply decreases, equilibrium quantity:",
  options: ["falls", "rises", "same", "zero"],
  answer: "falls"
},
{
  question: "Equilibrium ensures:",
  options: ["market balance", "loss", "waste", "profit"],
  answer: "market balance"
},
{
  question: "If demand is perfectly elastic, curve is:",
  options: ["horizontal", "vertical", "upward", "downward"],
  answer: "horizontal"
},
{
  question: "If supply is perfectly inelastic, curve is:",
  options: ["vertical", "horizontal", "upward", "downward"],
  answer: "vertical"
},
{
  question: "Shortage leads to:",
  options: ["price increase", "price fall", "no change", "loss"],
  answer: "price increase"
},
{
  question: "Surplus leads to:",
  options: ["price fall", "price rise", "no change", "profit"],
  answer: "price fall"
},

{
  question: "A market is defined as:",
  options: ["place where buyers and sellers interact", "shop only", "factory", "bank"],
  answer: "place where buyers and sellers interact"
},
{
  question: "Perfect competition is characterized by:",
  options: ["many buyers and sellers", "one seller", "few sellers", "government control"],
  answer: "many buyers and sellers"
},
{
  question: "In perfect competition, firms are:",
  options: ["price takers", "price makers", "monopolists", "oligopolists"],
  answer: "price takers"
},
{
  question: "A monopoly is a market with:",
  options: ["one seller", "many sellers", "few sellers", "no sellers"],
  answer: "one seller"
},
{
  question: "Oligopoly consists of:",
  options: ["few firms", "one firm", "many firms", "no firms"],
  answer: "few firms"
},
{
  question: "Monopolistic competition has:",
  options: ["many firms with product differentiation", "one firm", "few firms", "no competition"],
  answer: "many firms with product differentiation"
},
{
  question: "Total revenue (TR) =",
  options: ["price × quantity", "price + quantity", "cost × quantity", "profit"],
  answer: "price × quantity"
},
{
  question: "If price = GH¢5 and quantity = 20, TR is:",
  options: ["GH¢100", "GH¢25", "GH¢5", "GH¢20"],
  answer: "GH¢100"
},
{
  question: "Average revenue (AR) =",
  options: ["TR / quantity", "TR × quantity", "TR − quantity", "TR + quantity"],
  answer: "TR / quantity"
},
{
  question: "If TR = GH¢200 and output = 20, AR is:",
  options: ["GH¢10", "GH¢20", "GH¢5", "GH¢15"],
  answer: "GH¢10"
},
{
  question: "Marginal revenue (MR) is:",
  options: ["extra revenue from one more unit", "total revenue", "average revenue", "cost"],
  answer: "extra revenue from one more unit"
},
{
  question: "If TR rises from GH¢100 to GH¢120, MR is:",
  options: ["GH¢20", "GH¢100", "GH¢120", "GH¢220"],
  answer: "GH¢20"
},
{
  question: "Profit =",
  options: ["TR − TC", "TR + TC", "TC − TR", "TR / TC"],
  answer: "TR − TC"
},
{
  question: "If TR = GH¢500 and TC = GH¢300, profit is:",
  options: ["GH¢200", "GH¢500", "GH¢300", "GH¢800"],
  answer: "GH¢200"
},
{
  question: "If TR = GH¢400 and TC = GH¢500, result is:",
  options: ["GH¢100 loss", "GH¢100 profit", "GH¢400 profit", "GH¢500 loss"],
  answer: "GH¢100 loss"
},
{
  question: "In perfect competition, AR equals:",
  options: ["price", "cost", "profit", "TC"],
  answer: "price"
},
{
  question: "In monopoly, firm is:",
  options: ["price maker", "price taker", "neutral", "controlled"],
  answer: "price maker"
},
{
  question: "In perfect competition, MR equals:",
  options: ["price", "cost", "profit", "TC"],
  answer: "price"
},
{
  question: "Profit maximization occurs where:",
  options: ["MR = MC", "TR = TC", "AR = MR", "price = cost"],
  answer: "MR = MC"
},
{
  question: "If MR > MC, firm should:",
  options: ["increase output", "reduce output", "stop production", "no change"],
  answer: "increase output"
},
{
  question: "If MR < MC, firm should:",
  options: ["reduce output", "increase output", "no change", "stop"],
  answer: "reduce output"
},
{
  question: "Barriers to entry are highest in:",
  options: ["monopoly", "perfect competition", "monopolistic competition", "market"],
  answer: "monopoly"
},
{
  question: "Perfect competition firms earn:",
  options: ["normal profit in long run", "super profit always", "loss always", "zero output"],
  answer: "normal profit in long run"
},
{
  question: "Monopoly may earn:",
  options: ["supernormal profit", "only normal profit", "loss always", "zero"],
  answer: "supernormal profit"
},
{
  question: "Product differentiation is common in:",
  options: ["monopolistic competition", "perfect competition", "monopoly", "government"],
  answer: "monopolistic competition"
},
{
  question: "Price discrimination occurs in:",
  options: ["monopoly", "perfect competition", "market", "demand"],
  answer: "monopoly"
},
{
  question: "If output increases from 10 to 11 and TR rises from GH¢50 to GH¢55, MR:",
  options: ["GH¢5", "GH¢50", "GH¢55", "GH¢105"],
  answer: "GH¢5"
},
{
  question: "If cost per unit is GH¢4 and price is GH¢6, profit per unit:",
  options: ["GH¢2", "GH¢6", "GH¢4", "GH¢10"],
  answer: "GH¢2"
},
{
  question: "If a firm cannot influence price, it is:",
  options: ["price taker", "price maker", "monopoly", "oligopoly"],
  answer: "price taker"
},
{
  question: "Efficient market leads to:",
  options: ["optimal resource allocation", "waste", "loss", "inefficiency"],
  answer: "optimal resource allocation"
},

{
  question: "National income refers to:",
  options: ["total income of a country", "total profit", "total cost", "total savings"],
  answer: "total income of a country"
},
{
  question: "GDP stands for:",
  options: ["Gross Domestic Product", "Gross Development Product", "General Domestic Product", "Gross Demand Product"],
  answer: "Gross Domestic Product"
},
{
  question: "GNP stands for:",
  options: ["Gross National Product", "General National Product", "Gross Net Product", "Growth National Product"],
  answer: "Gross National Product"
},
{
  question: "GDP measures:",
  options: ["value of goods and services within a country", "income abroad", "imports only", "exports only"],
  answer: "value of goods and services within a country"
},
{
  question: "GNP =",
  options: ["GDP + net income from abroad", "GDP − imports", "GDP + exports", "GDP − taxes"],
  answer: "GDP + net income from abroad"
},
{
  question: "If GDP = GH¢100 billion and net income from abroad = GH¢10 billion, GNP:",
  options: ["GH¢110 billion", "GH¢100 billion", "GH¢90 billion", "GH¢120 billion"],
  answer: "GH¢110 billion"
},
{
  question: "Per capita income =",
  options: ["national income / population", "income × population", "GDP − population", "GDP × population"],
  answer: "national income / population"
},
{
  question: "If national income GH¢200 billion and population 100 million, per capita:",
  options: ["GH¢2,000", "GH¢200", "GH¢100", "GH¢20"],
  answer: "GH¢2,000"
},
{
  question: "Output method measures:",
  options: ["value of goods produced", "income only", "expenditure only", "tax"],
  answer: "value of goods produced"
},
{
  question: "Income method measures:",
  options: ["sum of wages, rent, interest, profit", "cost", "sales", "tax"],
  answer: "sum of wages, rent, interest, profit"
},
{
  question: "Expenditure method includes:",
  options: ["consumption + investment + government + net exports", "income only", "profit only", "cost only"],
  answer: "consumption + investment + government + net exports"
},
{
  question: "If consumption = 50, investment = 20, government = 15, net exports = 5, GDP:",
  options: ["90", "70", "50", "100"],
  answer: "90"
},
{
  question: "Net exports =",
  options: ["exports − imports", "imports − exports", "exports + imports", "exports × imports"],
  answer: "exports − imports"
},
{
  question: "If exports = 30 and imports = 20, net exports:",
  options: ["10", "50", "20", "30"],
  answer: "10"
},
{
  question: "Nominal GDP is:",
  options: ["measured at current prices", "adjusted for inflation", "real value", "constant price"],
  answer: "measured at current prices"
},
{
  question: "Real GDP is:",
  options: ["adjusted for inflation", "current prices", "nominal", "market price"],
  answer: "adjusted for inflation"
},
{
  question: "If nominal GDP rises due to price increase, real GDP:",
  options: ["may remain same", "always rises", "always falls", "zero"],
  answer: "may remain same"
},
{
  question: "Double counting should be avoided because:",
  options: ["it exaggerates output", "reduces output", "no effect", "increases tax"],
  answer: "it exaggerates output"
},
{
  question: "Value added =",
  options: ["output − intermediate cost", "output + cost", "cost − output", "profit"],
  answer: "output − intermediate cost"
},
{
  question: "If output = 100 and intermediate cost = 60, value added:",
  options: ["40", "100", "60", "160"],
  answer: "40"
},
{
  question: "Transfer payments include:",
  options: ["pensions", "wages", "rent", "profit"],
  answer: "pensions"
},
{
  question: "Transfer payments are excluded because:",
  options: ["no production involved", "they are income", "they increase GDP", "they reduce GDP"],
  answer: "no production involved"
},
{
  question: "Informal sector makes measurement:",
  options: ["difficult", "easy", "accurate", "perfect"],
  answer: "difficult"
},
{
  question: "High per capita income indicates:",
  options: ["higher standard of living", "low output", "low income", "poverty"],
  answer: "higher standard of living"
},
{
  question: "Low per capita income indicates:",
  options: ["low standard of living", "high income", "growth", "profit"],
  answer: "low standard of living"
},
{
  question: "Economic growth is measured by:",
  options: ["increase in real GDP", "increase in price", "increase in cost", "increase in tax"],
  answer: "increase in real GDP"
},
{
  question: "If GDP increases from 100 to 120, growth rate:",
  options: ["20%", "10%", "5%", "15%"],
  answer: "20%"
},
{
  question: "If GDP increases from 200 to 220, growth rate:",
  options: ["10%", "20%", "5%", "15%"],
  answer: "10%"
},
{
  question: "National income data helps in:",
  options: ["economic planning", "wasting resources", "loss", "reducing output"],
  answer: "economic planning"
},
{
  question: "Accurate national income ensures:",
  options: ["better decision making", "loss", "waste", "confusion"],
  answer: "better decision making"
},

{
  question: "Money is defined as:",
  options: ["anything generally accepted as a medium of exchange", "gold only", "coins only", "notes only"],
  answer: "anything generally accepted as a medium of exchange"
},
{
  question: "Primary function of money is:",
  options: ["medium of exchange", "store of value", "unit of account", "standard of deferred payment"],
  answer: "medium of exchange"
},
{
  question: "Money as a unit of account means:",
  options: ["measuring value of goods", "saving money", "paying debts", "trading"],
  answer: "measuring value of goods"
},
{
  question: "Store of value means:",
  options: ["money retains value over time", "money is spent", "money is taxed", "money is borrowed"],
  answer: "money retains value over time"
},
{
  question: "Standard of deferred payment means:",
  options: ["money used for future payments", "immediate payment", "cash only", "credit only"],
  answer: "money used for future payments"
},
{
  question: "Commodity money includes:",
  options: ["gold and silver", "paper notes", "coins only", "cheques"],
  answer: "gold and silver"
},
{
  question: "Fiat money is:",
  options: ["legal tender issued by government", "gold", "silver", "barter"],
  answer: "legal tender issued by government"
},
{
  question: "Near money includes:",
  options: ["bank deposits", "coins", "notes", "cash only"],
  answer: "bank deposits"
},
{
  question: "Barter system involves:",
  options: ["exchange of goods for goods", "money use", "banking", "credit"],
  answer: "exchange of goods for goods"
},
{
  question: "Major problem of barter system:",
  options: ["double coincidence of wants", "inflation", "tax", "interest"],
  answer: "double coincidence of wants"
},
{
  question: "Commercial banks accept:",
  options: ["deposits", "taxes", "laws", "goods"],
  answer: "deposits"
},
{
  question: "Commercial banks provide:",
  options: ["loans", "laws", "taxes", "goods"],
  answer: "loans"
},
{
  question: "Demand deposits are:",
  options: ["withdrawable anytime", "fixed", "long term", "government"],
  answer: "withdrawable anytime"
},
{
  question: "Time deposits are:",
  options: ["fixed for a period", "withdraw anytime", "free", "government"],
  answer: "fixed for a period"
},
{
  question: "Bank overdraft is:",
  options: ["short-term loan", "deposit", "tax", "profit"],
  answer: "short-term loan"
},
{
  question: "Cheque is:",
  options: ["written order to pay", "loan", "tax", "currency"],
  answer: "written order to pay"
},
{
  question: "Central bank is responsible for:",
  options: ["controlling money supply", "selling goods", "producing goods", "trading"],
  answer: "controlling money supply"
},
{
  question: "The central bank of Ghana is :",
  options: ["controller of monetary policy", "commercial bank", "trader", "producer"],
  answer: "controller of monetary policy"
},
{
  question: "Central bank acts as:",
  options: ["banker to government", "retailer", "consumer", "producer"],
  answer: "banker to government"
},
{
  question: "Central bank is lender of:",
  options: ["last resort", "first resort", "middle resort", "none"],
  answer: "last resort"
},
{
  question: "Open market operations involve:",
  options: ["buying and selling securities", "selling goods", "taxation", "borrowing"],
  answer: "buying and selling securities"
},
{
  question: "If central bank buys securities, money supply:",
  options: ["increases", "decreases", "same", "zero"],
  answer: "increases"
},
{
  question: "If central bank sells securities, money supply:",
  options: ["decreases", "increases", "same", "zero"],
  answer: "decreases"
},
{
  question: "Cash reserve ratio affects:",
  options: ["credit creation", "tax", "profit", "sales"],
  answer: "credit creation"
},
{
  question: "If reserve ratio increases, lending:",
  options: ["decreases", "increases", "same", "doubles"],
  answer: "decreases"
},
{
  question: "Credit creation is the ability of banks to:",
  options: ["create money through lending", "print money", "collect taxes", "produce goods"],
  answer: "create money through lending"
},
{
  question: "If a bank receives GH¢1,000 deposit and reserve ratio 10%, loanable amount:",
  options: ["GH¢900", "GH¢1,000", "GH¢100", "GH¢500"],
  answer: "GH¢900"
},
{
  question: "High inflation reduces value of:",
  options: ["money", "goods", "output", "income"],
  answer: "money"
},
{
  question: "Stable banking system ensures:",
  options: ["economic growth", "loss", "waste", "decline"],
  answer: "economic growth"
},
{
  question: "Efficient banking promotes:",
  options: ["investment", "waste", "loss", "inefficiency"],
  answer: "investment"
},

{
  question: "Inflation is defined as:",
  options: ["general rise in price level", "fall in price", "stable prices", "increase in output"],
  answer: "general rise in price level"
},
{
  question: "Deflation is:",
  options: ["general fall in price level", "rise in prices", "stable prices", "high income"],
  answer: "general fall in price level"
},
{
  question: "Creeping inflation refers to:",
  options: ["slow increase in prices", "rapid increase", "no change", "fall in price"],
  answer: "slow increase in prices"
},
{
  question: "Hyperinflation refers to:",
  options: ["very rapid price increase", "slow increase", "stable prices", "fall in price"],
  answer: "very rapid price increase"
},
{
  question: "Demand-pull inflation is caused by:",
  options: ["excess demand over supply", "high cost", "low income", "low demand"],
  answer: "excess demand over supply"
},
{
  question: "Cost-push inflation is caused by:",
  options: ["increase in production cost", "high demand", "low cost", "high output"],
  answer: "increase in production cost"
},
{
  question: "If wages increase without productivity increase, inflation is:",
  options: ["cost-push", "demand-pull", "creeping", "deflation"],
  answer: "cost-push"
},
{
  question: "If government increases spending, inflation may be:",
  options: ["demand-pull", "cost-push", "deflation", "stable"],
  answer: "demand-pull"
},
{
  question: "Inflation reduces:",
  options: ["purchasing power", "income", "output", "profit"],
  answer: "purchasing power"
},
{
  question: "Those most affected by inflation are:",
  options: ["fixed income earners", "business owners", "investors", "entrepreneurs"],
  answer: "fixed income earners"
},
{
  question: "Inflation benefits:",
  options: ["borrowers", "lenders", "savers", "workers"],
  answer: "borrowers"
},
{
  question: "Inflation harms:",
  options: ["savers", "borrowers", "producers", "government"],
  answer: "savers"
},
{
  question: "Inflation rate is calculated as:",
  options: ["percentage change in price level", "price × quantity", "cost − revenue", "income − tax"],
  answer: "percentage change in price level"
},
{
  question: "If price index rises from 100 to 110, inflation rate:",
  options: ["10%", "5%", "15%", "20%"],
  answer: "10%"
},
{
  question: "If price index rises from 200 to 240, inflation rate:",
  options: ["20%", "10%", "40%", "15%"],
  answer: "20%"
},
{
  question: "Monetary policy controls inflation by:",
  options: ["controlling money supply", "increasing wages", "reducing output", "raising cost"],
  answer: "controlling money supply"
},
{
  question: "Fiscal policy controls inflation through:",
  options: ["tax and government spending", "printing money", "production only", "imports"],
  answer: "tax and government spending"
},
{
  question: "Unemployment is:",
  options: ["people willing and able to work but no job", "people working", "students", "retired"],
  answer: "people willing and able to work but no job"
},
{
  question: "Frictional unemployment is:",
  options: ["short-term job search", "long-term", "no skills", "seasonal"],
  answer: "short-term job search"
},
{
  question: "Structural unemployment is caused by:",
  options: ["change in economy structure", "weather", "holiday", "short-term"],
  answer: "change in economy structure"
},
{
  question: "Seasonal unemployment occurs due to:",
  options: ["seasonal work changes", "technology", "education", "training"],
  answer: "seasonal work changes"
},
{
  question: "Cyclical unemployment is caused by:",
  options: ["economic downturn", "weather", "skills", "training"],
  answer: "economic downturn"
},
{
  question: "Underemployment means:",
  options: ["working below capacity", "no job", "full employment", "retired"],
  answer: "working below capacity"
},
{
  question: "Full employment means:",
  options: ["no involuntary unemployment", "everyone employed", "no jobs", "low income"],
  answer: "no involuntary unemployment"
},
{
  question: "High unemployment leads to:",
  options: ["low income", "high income", "growth", "profit"],
  answer: "low income"
},
{
  question: "Unemployment increases:",
  options: ["poverty", "income", "production", "investment"],
  answer: "poverty"
},
{
  question: "Government can reduce unemployment by:",
  options: ["creating jobs", "reducing production", "increasing tax", "reducing wages"],
  answer: "creating jobs"
},
{
  question: "Training programs help reduce:",
  options: ["structural unemployment", "frictional", "seasonal", "cyclical"],
  answer: "structural unemployment"
},
{
  question: "Economic growth helps reduce:",
  options: ["unemployment", "inflation", "tax", "cost"],
  answer: "unemployment"
},
{
  question: "Stable economy ensures:",
  options: ["low inflation and unemployment", "high inflation", "high unemployment", "loss"],
  answer: "low inflation and unemployment"
},

{
  question: "Public finance deals with:",
  options: ["government revenue and expenditure", "private business", "consumer behavior", "production"],
  answer: "government revenue and expenditure"
},
{
  question: "Government revenue mainly comes from:",
  options: ["taxation", "sales", "production", "exports"],
  answer: "taxation"
},
{
  question: "A tax is:",
  options: ["compulsory payment to government", "voluntary payment", "loan", "profit"],
  answer: "compulsory payment to government"
},
{
  question: "Direct tax is paid by:",
  options: ["the same person who bears the burden", "another person", "government", "bank"],
  answer: "the same person who bears the burden"
},
{
  question: "Indirect tax is:",
  options: ["shifted to others", "paid directly", "free", "optional"],
  answer: "shifted to others"
},
{
  question: "Example of direct tax is:",
  options: ["income tax", "VAT", "sales tax", "import duty"],
  answer: "income tax"
},
{
  question: "Example of indirect tax is:",
  options: ["VAT", "income tax", "property tax", "poll tax"],
  answer: "VAT"
},
{
  question: "A progressive tax means:",
  options: ["higher income, higher tax rate", "same rate", "lower rate", "no tax"],
  answer: "higher income, higher tax rate"
},
{
  question: "A regressive tax means:",
  options: ["lower income pays higher proportion", "higher income pays more", "same rate", "no tax"],
  answer: "lower income pays higher proportion"
},
{
  question: "A proportional tax means:",
  options: ["same rate for all incomes", "higher income pays more", "lower income pays more", "no tax"],
  answer: "same rate for all incomes"
},
{
  question: "Tax revenue =",
  options: ["tax rate × tax base", "income × cost", "profit × tax", "cost × revenue"],
  answer: "tax rate × tax base"
},
{
  question: "If tax rate is 10% on income GH¢1,000, tax:",
  options: ["GH¢100", "GH¢10", "GH¢1,000", "GH¢200"],
  answer: "GH¢100"
},
{
  question: "If VAT is 15% on GH¢200, VAT amount:",
  options: ["GH¢30", "GH¢15", "GH¢20", "GH¢50"],
  answer: "GH¢30"
},
{
  question: "Government expenditure includes:",
  options: ["spending on services", "private spending", "business cost", "profit"],
  answer: "spending on services"
},
{
  question: "Capital expenditure is:",
  options: ["long-term investment", "daily spending", "wages", "rent"],
  answer: "long-term investment"
},
{
  question: "Recurrent expenditure is:",
  options: ["day-to-day spending", "investment", "assets", "capital"],
  answer: "day-to-day spending"
},
{
  question: "A government budget is:",
  options: ["estimate of revenue and expenditure", "profit statement", "balance sheet", "ledger"],
  answer: "estimate of revenue and expenditure"
},
{
  question: "Balanced budget means:",
  options: ["revenue equals expenditure", "revenue > expenditure", "expenditure > revenue", "no spending"],
  answer: "revenue equals expenditure"
},
{
  question: "Budget surplus occurs when:",
  options: ["revenue > expenditure", "expenditure > revenue", "equal", "zero"],
  answer: "revenue > expenditure"
},
{
  question: "Budget deficit occurs when:",
  options: ["expenditure > revenue", "revenue > expenditure", "equal", "zero"],
  answer: "expenditure > revenue"
},
{
  question: "Fiscal policy refers to:",
  options: ["government use of tax and spending", "money supply", "banking", "trade"],
  answer: "government use of tax and spending"
},
{
  question: "Expansionary fiscal policy aims to:",
  options: ["increase economic activity", "reduce spending", "increase tax", "reduce output"],
  answer: "increase economic activity"
},
{
  question: "Contractionary fiscal policy aims to:",
  options: ["reduce inflation", "increase spending", "increase output", "increase employment"],
  answer: "reduce inflation"
},
{
  question: "If government increases spending, economy:",
  options: ["grows", "shrinks", "same", "zero"],
  answer: "grows"
},
{
  question: "If government increases taxes, consumption:",
  options: ["falls", "rises", "same", "doubles"],
  answer: "falls"
},
{
  question: "Public debt arises when:",
  options: ["government borrows", "government saves", "government spends", "government taxes"],
  answer: "government borrows"
},
{
  question: "Internal debt is borrowed from:",
  options: ["within the country", "outside country", "banks only", "firms"],
  answer: "within the country"
},
{
  question: "External debt is borrowed from:",
  options: ["foreign sources", "local banks", "citizens", "firms"],
  answer: "foreign sources"
},
{
  question: "Efficient taxation ensures:",
  options: ["fair income distribution", "inequality", "loss", "waste"],
  answer: "fair income distribution"
},
{
  question: "Good fiscal policy promotes:",
  options: ["economic stability", "inflation", "unemployment", "loss"],
  answer: "economic stability"
},

{
  question: "International trade is the exchange of:",
  options: ["goods and services between countries", "goods within country", "money only", "labour only"],
  answer: "goods and services between countries"
},
{
  question: "Exports are:",
  options: ["goods sold to other countries", "goods bought", "local goods", "services only"],
  answer: "goods sold to other countries"
},
{
  question: "Imports are:",
  options: ["goods bought from abroad", "goods sold abroad", "local goods", "services"],
  answer: "goods bought from abroad"
},
{
  question: "Visible trade refers to:",
  options: ["trade in goods", "trade in services", "capital flow", "loans"],
  answer: "trade in goods"
},
{
  question: "Invisible trade refers to:",
  options: ["trade in services", "goods only", "imports", "exports"],
  answer: "trade in services"
},
{
  question: "Balance of trade =",
  options: ["exports − imports", "imports − exports", "exports + imports", "exports × imports"],
  answer: "exports − imports"
},
{
  question: "If exports = 50 and imports = 40, BOT:",
  options: ["10", "50", "40", "90"],
  answer: "10"
},
{
  question: "If imports exceed exports, it is:",
  options: ["trade deficit", "trade surplus", "balance", "growth"],
  answer: "trade deficit"
},
{
  question: "If exports exceed imports, it is:",
  options: ["trade surplus", "deficit", "balance", "loss"],
  answer: "trade surplus"
},
{
  question: "Balance of payments includes:",
  options: ["all transactions with foreign countries", "goods only", "services only", "tax only"],
  answer: "all transactions with foreign countries"
},
{
  question: "Current account includes:",
  options: ["trade in goods and services", "capital flows", "loans", "reserves"],
  answer: "trade in goods and services"
},
{
  question: "Capital account includes:",
  options: ["investment and loans", "goods", "services", "consumption"],
  answer: "investment and loans"
},
{
  question: "Exchange rate is:",
  options: ["price of one currency in terms of another", "price of goods", "interest rate", "tax"],
  answer: "price of one currency in terms of another"
},
{
  question: "If $1 = GH¢10, this means:",
  options: ["1 dollar equals 10 cedis", "10 dollars equals 1 cedi", "1 cedi equals 10 dollars", "none"],
  answer: "1 dollar equals 10 cedis"
},
{
  question: "If exchange rate changes from GH¢10 to GH¢12 per $1, cedi:",
  options: ["depreciates", "appreciates", "stable", "fixed"],
  answer: "depreciates"
},
{
  question: "If exchange rate changes from GH¢12 to GH¢10 per $1, cedi:",
  options: ["appreciates", "depreciates", "stable", "falls"],
  answer: "appreciates"
},
{
  question: "Depreciation of currency makes exports:",
  options: ["cheaper", "expensive", "same", "zero"],
  answer: "cheaper"
},
{
  question: "Depreciation makes imports:",
  options: ["more expensive", "cheaper", "same", "free"],
  answer: "more expensive"
},
{
  question: "Appreciation of currency makes imports:",
  options: ["cheaper", "expensive", "same", "zero"],
  answer: "cheaper"
},
{
  question: "Exchange rate determined by demand and supply is:",
  options: ["floating", "fixed", "pegged", "controlled"],
  answer: "floating"
},
{
  question: "Fixed exchange rate is set by:",
  options: ["government", "market", "consumers", "banks"],
  answer: "government"
},
{
  question: "Tariff is:",
  options: ["tax on imports", "subsidy", "loan", "export"],
  answer: "tax on imports"
},
{
  question: "Quota is:",
  options: ["limit on imports", "tax", "loan", "export"],
  answer: "limit on imports"
},
{
  question: "Protectionism aims to:",
  options: ["protect local industries", "increase imports", "reduce exports", "free trade"],
  answer: "protect local industries"
},
{
  question: "Free trade means:",
  options: ["no trade restrictions", "high tax", "quota", "control"],
  answer: "no trade restrictions"
},
{
  question: "Comparative advantage means:",
  options: ["lower opportunity cost", "higher cost", "equal cost", "zero cost"],
  answer: "lower opportunity cost"
},
{
  question: "If country A produces at lower cost than B, A has:",
  options: ["comparative advantage", "absolute disadvantage", "no advantage", "loss"],
  answer: "comparative advantage"
},
{
  question: "International trade leads to:",
  options: ["specialization", "waste", "loss", "inefficiency"],
  answer: "specialization"
},
{
  question: "If exports increase, GDP:",
  options: ["increases", "decreases", "same", "zero"],
  answer: "increases"
},
{
  question: "Balanced trade means:",
  options: ["exports = imports", "exports > imports", "imports > exports", "no trade"],
  answer: "exports = imports"
},

{
  question: "Economic growth refers to:",
  options: ["increase in real GDP", "increase in population", "increase in price", "increase in cost"],
  answer: "increase in real GDP"
},
{
  question: "Economic development refers to:",
  options: ["improvement in living standards", "increase in GDP only", "increase in tax", "increase in cost"],
  answer: "improvement in living standards"
},
{
  question: "Development includes:",
  options: ["education, health, income", "income only", "cost only", "profit only"],
  answer: "education, health, income"
},
{
  question: "GDP growth without development means:",
  options: ["no improvement in welfare", "high development", "growth equals development", "perfect economy"],
  answer: "no improvement in welfare"
},
{
  question: "Human Development Index (HDI) measures:",
  options: ["health, education, income", "GDP only", "tax", "cost"],
  answer: "health, education, income"
},
{
  question: "High HDI indicates:",
  options: ["high standard of living", "low income", "poverty", "unemployment"],
  answer: "high standard of living"
},
{
  question: "Low HDI indicates:",
  options: ["poor living standards", "high income", "growth", "profit"],
  answer: "poor living standards"
},
{
  question: "Poverty is defined as:",
  options: ["lack of basic needs", "high income", "profit", "wealth"],
  answer: "lack of basic needs"
},
{
  question: "Absolute poverty means:",
  options: ["inability to meet basic needs", "relative difference", "wealth", "income"],
  answer: "inability to meet basic needs"
},
{
  question: "Relative poverty means:",
  options: ["comparison with others", "no food", "no income", "no shelter"],
  answer: "comparison with others"
},
{
  question: "Unemployment contributes to:",
  options: ["poverty", "growth", "profit", "development"],
  answer: "poverty"
},
{
  question: "High population growth may lead to:",
  options: ["pressure on resources", "growth only", "profit", "wealth"],
  answer: "pressure on resources"
},
{
  question: "Low level of education leads to:",
  options: ["low productivity", "high productivity", "growth", "profit"],
  answer: "low productivity"
},
{
  question: "Infrastructure includes:",
  options: ["roads, electricity, water", "goods", "profit", "tax"],
  answer: "roads, electricity, water"
},
{
  question: "Poor infrastructure leads to:",
  options: ["low development", "high growth", "profit", "wealth"],
  answer: "low development"
},
{
  question: "Investment in education improves:",
  options: ["human capital", "cost", "loss", "tax"],
  answer: "human capital"
},
{
  question: "Savings help development by:",
  options: ["providing funds for investment", "reducing income", "increasing cost", "causing loss"],
  answer: "providing funds for investment"
},
{
  question: "Foreign aid is:",
  options: ["assistance from other countries", "tax", "profit", "loan only"],
  answer: "assistance from other countries"
},
{
  question: "Overdependence on aid may:",
  options: ["reduce self-reliance", "increase growth", "increase profit", "reduce poverty"],
  answer: "reduce self-reliance"
},
{
  question: "Industrialization helps development by:",
  options: ["creating jobs", "reducing output", "increasing cost", "causing loss"],
  answer: "creating jobs"
},
{
  question: "Diversification means:",
  options: ["expanding economic activities", "one product only", "reducing output", "loss"],
  answer: "expanding economic activities"
},
{
  question: "Good governance promotes:",
  options: ["development", "corruption", "loss", "waste"],
  answer: "development"
},
{
  question: "Corruption leads to:",
  options: ["underdevelopment", "growth", "profit", "wealth"],
  answer: "underdevelopment"
},
{
  question: "If GDP rises from 100 to 130, growth rate:",
  options: ["30%", "20%", "10%", "15%"],
  answer: "30%"
},
{
  question: "If population grows faster than GDP:",
  options: ["living standard falls", "rises", "same", "zero"],
  answer: "living standard falls"
},
{
  question: "Economic planning helps:",
  options: ["allocate resources efficiently", "waste resources", "increase cost", "reduce output"],
  answer: "allocate resources efficiently"
},
{
  question: "Sustainable development means:",
  options: ["meeting present needs without harming future", "using all resources now", "waste", "loss"],
  answer: "meeting present needs without harming future"
},
{
  question: "Environmental protection ensures:",
  options: ["long-term development", "short-term gain only", "loss", "waste"],
  answer: "long-term development"
},
{
  question: "Technology improves:",
  options: ["productivity", "waste", "loss", "cost"],
  answer: "productivity"
},
{
  question: "Development policies aim at:",
  options: ["improving quality of life", "increasing cost", "reducing income", "loss"],
  answer: "improving quality of life"
},

{
  question: "If price falls from GH¢10 to GH¢8 and quantity rises from 20 to 30, demand is:",
  options: ["elastic", "inelastic", "unitary", "perfect"],
  answer: "elastic"
},
{
  question: "If price rises by 10% and quantity supplied rises by 5%, PES:",
  options: ["0.5", "2", "1", "10"],
  answer: "0.5"
},
{
  question: "Opportunity cost of choosing school instead of work is:",
  options: ["income forgone", "fees paid", "books", "transport"],
  answer: "income forgone"
},
{
  question: "If MU = 6 and price = 6, consumer:",
  options: ["is in equilibrium", "should buy more", "should buy less", "should stop"],
  answer: "is in equilibrium"
},
{
  question: "If TC = 600 and output = 50, AC:",
  options: ["12", "600", "50", "30"],
  answer: "12"
},
{
  question: "If TC rises from 400 to 460 when output rises by 10, MC:",
  options: ["6", "60", "10", "20"],
  answer: "6"
},
{
  question: "If TR = 500 and TC = 350, profit:",
  options: ["150", "500", "350", "850"],
  answer: "150"
},
{
  question: "Perfect competition firms are:",
  options: ["price takers", "price makers", "monopolists", "oligopolists"],
  answer: "price takers"
},
{
  question: "If GDP = 200 and net income abroad = 20, GNP:",
  options: ["220", "200", "180", "240"],
  answer: "220"
},
{
  question: "If price index rises from 100 to 120, inflation:",
  options: ["20%", "10%", "5%", "15%"],
  answer: "20%"
},
{
  question: "If exports = 60 and imports = 40, BOT:",
  options: ["20", "60", "40", "100"],
  answer: "20"
},
{
  question: "If exchange rate changes from GH¢10 to GH¢12 per $1, currency:",
  options: ["depreciates", "appreciates", "stable", "fixed"],
  answer: "depreciates"
},
{
  question: "If income rises and demand falls, good is:",
  options: ["inferior", "normal", "luxury", "free"],
  answer: "inferior"
},
{
  question: "If supply increases, equilibrium price:",
  options: ["falls", "rises", "same", "zero"],
  answer: "falls"
},
{
  question: "If demand increases, equilibrium quantity:",
  options: ["rises", "falls", "same", "zero"],
  answer: "rises"
},
{
  question: "Bank reserve ratio increase leads to:",
  options: ["less lending", "more lending", "same", "profit"],
  answer: "less lending"
},
{
  question: "If deposit = 2000 and reserve ratio 10%, loan:",
  options: ["1800", "2000", "200", "1000"],
  answer: "1800"
},
{
  question: "Government deficit occurs when:",
  options: ["spending > revenue", "revenue > spending", "equal", "zero"],
  answer: "spending > revenue"
},
{
  question: "Progressive tax means:",
  options: ["higher income pays higher rate", "same rate", "lower rate", "zero"],
  answer: "higher income pays higher rate"
},
{
  question: "Unemployment due to recession is:",
  options: ["cyclical", "frictional", "seasonal", "structural"],
  answer: "cyclical"
},
{
  question: "If GDP rises faster than population, living standard:",
  options: ["rises", "falls", "same", "zero"],
  answer: "rises"
},
{
  question: "If imports exceed exports, it is:",
  options: ["deficit", "surplus", "balance", "growth"],
  answer: "deficit"
},
{
  question: "If price falls and TR increases, demand:",
  options: ["elastic", "inelastic", "unitary", "zero"],
  answer: "elastic"
},
{
  question: "If MU < price, consumer should:",
  options: ["consume less", "consume more", "stop", "no change"],
  answer: "consume less"
},
{
  question: "If TC = 300 and FC = 100, VC:",
  options: ["200", "300", "100", "400"],
  answer: "200"
},
{
  question: "If output rises and AFC falls, reason:",
  options: ["fixed cost spread", "variable cost rise", "profit", "loss"],
  answer: "fixed cost spread"
},
{
  question: "If government increases tax, consumption:",
  options: ["falls", "rises", "same", "doubles"],
  answer: "falls"
},
{
  question: "If currency appreciates, imports:",
  options: ["increase", "decrease", "same", "zero"],
  answer: "increase"
},
{
  question: "HDI measures:",
  options: ["health, education, income", "GDP only", "tax", "cost"],
  answer: "health, education, income"
},
{
  question: "Economic growth is measured by:",
  options: ["real GDP", "nominal GDP", "price", "cost"],
  answer: "real GDP"
},

{
  question: "Price falls from GH¢20 to GH¢16 and quantity rises from 10 to 14. PED:",
  options: ["2", "0.5", "1", "4"],
  answer: "2"
},
{
  question: "Price rises from GH¢10 to GH¢12 and quantity falls from 20 to 18. PED:",
  options: ["1", "2", "0.5", "3"],
  answer: "1"
},
{
  question: "Price rises 20% and quantity supplied rises 10%. PES:",
  options: ["0.5", "2", "1", "10"],
  answer: "0.5"
},
{
  question: "Total utility increases from 50 to 70 when quantity increases from 5 to 6. MU:",
  options: ["20", "70", "50", "10"],
  answer: "20"
},
{
  question: "If MU = 8 and price = 4, what should consumer do?",
  options: ["buy more", "buy less", "stop", "no change"],
  answer: "buy more"
},
{
  question: "If TP = 200 and labour = 10, AP:",
  options: ["20", "200", "10", "100"],
  answer: "20"
},
{
  question: "If TP rises from 150 to 180 when labour increases by 1, MP:",
  options: ["30", "150", "180", "330"],
  answer: "30"
},
{
  question: "If TC = 800 and output = 40, AC:",
  options: ["20", "40", "800", "10"],
  answer: "20"
},
{
  question: "If TC rises from 600 to 660 when output rises by 10, MC:",
  options: ["6", "60", "10", "20"],
  answer: "6"
},
{
  question: "If TR = 1000 and output = 50, AR:",
  options: ["20", "50", "1000", "10"],
  answer: "20"
},
{
  question: "If TR rises from 500 to 550 when output increases by 5, MR:",
  options: ["10", "50", "5", "100"],
  answer: "10"
},
{
  question: "If TR = 700 and TC = 500, profit:",
  options: ["200", "700", "500", "1200"],
  answer: "200"
},
{
  question: "If GDP = 300 and net income abroad = -20, GNP:",
  options: ["280", "300", "320", "260"],
  answer: "280"
},
{
  question: "If consumption = 100, investment = 40, government = 30, net exports = 10, GDP:",
  options: ["180", "170", "160", "200"],
  answer: "180"
},
{
  question: "If national income = 500 and population = 100, per capita income:",
  options: ["5", "50", "500", "100"],
  answer: "5"
},
{
  question: "Price index rises from 120 to 150. Inflation rate:",
  options: ["25%", "20%", "30%", "15%"],
  answer: "25%"
},
{
  question: "Price index rises from 200 to 220. Inflation rate:",
  options: ["10%", "20%", "5%", "15%"],
  answer: "10%"
},
{
  question: "If tax rate is 20% on income GH¢5000, tax:",
  options: ["GH¢1000", "GH¢500", "GH¢2000", "GH¢1500"],
  answer: "GH¢1000"
},
{
  question: "If VAT is 15% on GH¢400, VAT amount:",
  options: ["GH¢60", "GH¢40", "GH¢15", "GH¢100"],
  answer: "GH¢60"
},
{
  question: "If exports = 80 and imports = 50, BOT:",
  options: ["30", "80", "50", "130"],
  answer: "30"
},
{
  question: "If exchange rate is GH¢12 per $1, value of $10:",
  options: ["GH¢120", "GH¢12", "GH¢10", "GH¢100"],
  answer: "GH¢120"
},
{
  question: "If exchange rate changes from GH¢10 to GH¢8 per $1, cedi:",
  options: ["appreciates", "depreciates", "stable", "falls"],
  answer: "appreciates"
},
{
  question: "If output rises from 100 to 130, growth rate:",
  options: ["30%", "20%", "10%", "15%"],
  answer: "30%"
},
{
  question: "If GDP rises from 400 to 440, growth rate:",
  options: ["10%", "20%", "5%", "15%"],
  answer: "10%"
},
{
  question: "If FC = 300 and output = 15, AFC:",
  options: ["20", "300", "15", "10"],
  answer: "20"
},
{
  question: "If VC = 500 and output = 25, AVC:",
  options: ["20", "25", "500", "10"],
  answer: "20"
},
{
  question: "If price = GH¢5 and quantity = 100, TR:",
  options: ["500", "100", "5", "50"],
  answer: "500"
},
{
  question: "If MC = 10 and MR = 15, firm should:",
  options: ["increase output", "reduce output", "stop", "no change"],
  answer: "increase output"
},
{
  question: "If MC = 20 and MR = 10, firm should:",
  options: ["reduce output", "increase output", "stop", "no change"],
  answer: "reduce output"
},

{
  question: "The diagram shows a demand curve. What happens to quantity demanded when price increases?",
  image: "/images/econ_shs1.png",
  options: ["Increases", "Decreases", "Remains constant", "Becomes zero"],
  answer: "Decreases"
},

{
  question: "The diagram shows a supply curve. What happens to quantity supplied as price rises?",
  image: "/images/econ_shs2.png",
  options: ["Decreases", "Increases", "Remains constant", "Becomes zero"],
  answer: "Increases"
},

{
  question: "The diagram shows demand and supply curves intersecting. What does the intersection point represent?",
  image: "/images/econ_shs3.png",
  options: ["Shortage", "Surplus", "Equilibrium", "Inflation"],
  answer: "Equilibrium"
},

{
  question: "The diagram shows a shift of the demand curve from D to D1. What has occurred?",
  image: "/images/econ_shs4.png",
  options: ["Increase in demand", "Decrease in demand", "Increase in supply", "Decrease in supply"],
  answer: "Increase in demand"
},

{
  question: "The diagram shows a shift in supply curve from S to S1 to the right. What does this indicate?",
  image: "/images/econ_shs5.png",
  options: ["Decrease in supply", "Increase in supply", "Decrease in demand", "No change"],
  answer: "Increase in supply"
},

{
  question: "The diagram shows a price set above equilibrium. What situation is created?",
  image: "/images/econ_shs6.png",
  options: ["Shortage", "Surplus", "Equilibrium", "Deficit"],
  answer: "Surplus"
},

{
  question: "The diagram shows a price set below equilibrium. What situation occurs?",
  image: "/images/econ_shs7.png",
  options: ["Surplus", "Shortage", "Equilibrium", "Stability"],
  answer: "Shortage"
},

{
  question: "The diagram shows a perfectly inelastic demand curve. What is its shape?",
  image: "/images/econ_shs8.png",
  options: ["Horizontal", "Vertical", "Downward sloping", "Upward sloping"],
  answer: "Vertical"
},

{
  question: "The diagram shows a perfectly elastic demand curve. What is its shape?",
  image: "/images/econ_shs9.png",
  options: ["Vertical", "Horizontal", "Curved", "Upward sloping"],
  answer: "Horizontal"
},

{
  question: "The diagram shows production possibility curve (PPC). What does a point inside the curve represent?",
  image: "/images/econ_shs10.png",
  options: ["Efficiency", "Inefficiency", "Maximum output", "Growth"],
  answer: "Inefficiency"
},

{
  question: "The diagram shows a demand curve with a relatively flat slope. What type of elasticity does it represent?",
  image: "/images/econ_shs11.png",
  options: ["Perfectly inelastic", "Relatively elastic", "Unitary elastic", "Relatively inelastic"],
  answer: "Relatively elastic"
},

{
  question: "The diagram shows a steep demand curve. What does this indicate?",
  image: "/images/econ_shs12.png",
  options: ["Elastic demand", "Inelastic demand", "Perfect competition", "Unit elasticity"],
  answer: "Inelastic demand"
},

{
  question: "The diagram shows Total Revenue (TR) curve increasing and then decreasing. At what point is TR maximized?",
  image: "/images/econ_shs13.png",
  options: ["At the highest price", "At midpoint of demand curve", "At zero output", "At minimum cost"],
  answer: "At midpoint of demand curve"
},

{
  question: "The diagram shows Marginal Revenue (MR) and Average Revenue (AR). Where does MR lie relative to AR?",
  image: "/images/econ_shs14.png",
  options: ["Above AR", "Below AR", "Equal to AR always", "Unrelated"],
  answer: "Below AR"
},

{
  question: "The diagram shows U-shaped Average Cost (AC) and Marginal Cost (MC) curves. At what point does MC intersect AC?",
  image: "/images/econ_shs15.png",
  options: ["Minimum point of AC", "Maximum point of AC", "Beginning of AC", "End of AC"],
  answer: "Minimum point of AC"
},

{
  question: "The diagram shows a firm making supernormal profit. What condition is shown?",
  image: "/images/econ_shs16.png",
  options: ["AR > AC", "AR < AC", "AR = AC", "MC = 0"],
  answer: "AR > AC"
},

{
  question: "The diagram shows a firm making a loss. What condition applies?",
  image: "/images/econ_shs17.png",
  options: ["AR > AC", "AR = AC", "AR < AC", "MC > AC"],
  answer: "AR < AC"
},

{
  question: "The diagram shows perfect competition equilibrium. What is true at equilibrium?",
  image: "/images/econ_shs18.png",
  options: ["MR = MC", "AR > MC", "MC > MR", "TR = TC"],
  answer: "MR = MC"
},

{
  question: "The diagram shows a monopoly firm. Why is the demand curve downward sloping?",
  image: "/images/econ_shs19.png",
  options: ["Firm is price taker", "Firm controls price", "Market is perfect", "Supply is fixed"],
  answer: "Firm controls price"
},

{
  question: "The diagram shows long-run equilibrium under perfect competition. What happens to profit?",
  image: "/images/econ_shs20.png",
  options: ["Supernormal profit", "Loss", "Normal profit", "Zero output"],
  answer: "Normal profit"
},

{
  question: "If deposit = 5000 and reserve ratio 20%, loan:",
  options: ["4000", "5000", "1000", "3000"],
  answer: "4000"
}
];

export default economicsQuestions;